/**
 * Commission catalog fixtures aligned with pga-backend graphql-schemas/backoffice.graphql.
 * Fields and enum values mirror BackofficeCommissionProgram, Partner, Campaign, and Enrollment.
 */
import type { CommissionCampaignNode } from "../campaigns/types";
import type { CommissionEnrollmentNode } from "../enrollments/types";
import type { CommissionPartnerNode } from "@/pages/people/operations/golf-retirement-plus/partners/types";
import type { CommissionProgramNode } from "../programs/types";

export const commissionProgramFixtures: CommissionProgramNode[] = [
  {
    id: "commission-program-grp",
    name: "Golf Retirement Plus",
    slug: "grp",
    status: "ACTIVE"
  },
  {
    id: "commission-program-legacy",
    name: "Legacy Sponsor Incentive",
    slug: "legacy-sponsor-incentive",
    status: "ARCHIVED"
  }
];

export const commissionIngestRecipeFixtures: Record<string, string> = {
  "commission-partner-acme": "11111111-1111-4111-8111-111111111111",
  "commission-partner-fairway": "22222222-2222-4222-8222-222222222222",
  "commission-partner-retired": "33333333-3333-4333-8333-333333333333"
};

export const commissionPartnerFixtures: CommissionPartnerNode[] = [
  {
    id: "commission-partner-acme",
    name: "Acme Golf Sponsors",
    legacyId: "SP-1042",
    status: "ACTIVE"
  },
  {
    id: "commission-partner-fairway",
    name: "Fairway Financial Group",
    legacyId: "SP-2088",
    status: "ACTIVE"
  },
  {
    id: "commission-partner-retired",
    name: "Sunset Equipment Co.",
    legacyId: "SP-0199",
    status: "INACTIVE"
  }
];

const grpProgramSummary = {
  id: "commission-program-grp",
  name: "Golf Retirement Plus",
  slug: "grp"
};

export const commissionCampaignFixtures: CommissionCampaignNode[] = [
  {
    id: "commission-campaign-2026-acme",
    editionYear: 2026,
    status: "ACTIVE",
    payoutCadence: "QUARTERLY",
    eligibilityRules: [],
    startsAt: "2026-01-01T00:00:00Z",
    endsAt: "2026-12-31T23:59:59Z",
    partner: {
      id: "commission-partner-acme",
      name: "Acme Golf Sponsors",
      currentIngestRecipe: { id: commissionIngestRecipeFixtures["commission-partner-acme"] }
    },
    program: grpProgramSummary
  },
  {
    id: "commission-campaign-2026-fairway",
    editionYear: 2026,
    status: "DRAFT",
    payoutCadence: "QUARTERLY",
    eligibilityRules: [],
    startsAt: "2026-04-01T00:00:00Z",
    endsAt: "2027-03-31T23:59:59Z",
    partner: {
      id: "commission-partner-fairway",
      name: "Fairway Financial Group",
      currentIngestRecipe: { id: commissionIngestRecipeFixtures["commission-partner-fairway"] }
    },
    program: grpProgramSummary
  },
  {
    id: "commission-campaign-2025-acme",
    editionYear: 2025,
    status: "CLOSED",
    payoutCadence: "QUARTERLY",
    eligibilityRules: [],
    startsAt: "2025-01-01T00:00:00Z",
    endsAt: "2025-12-31T23:59:59Z",
    partner: {
      id: "commission-partner-acme",
      name: "Acme Golf Sponsors",
      currentIngestRecipe: { id: commissionIngestRecipeFixtures["commission-partner-acme"] }
    },
    program: grpProgramSummary
  }
];

export const commissionEnrollmentFixtures: CommissionEnrollmentNode[] = [
  {
    id: "commission-enrollment-ada",
    accountStatus: "ACTIVE",
    person: {
      id: "person-ada",
      displayName: "Ada Lovelace",
      pgaId: "12345678"
    },
    program: grpProgramSummary
  },
  {
    id: "commission-enrollment-bobby",
    accountStatus: "ACTIVE",
    person: {
      id: "person-bobby",
      displayName: "Bobby Jones",
      pgaId: "87654321"
    },
    program: grpProgramSummary
  },
  {
    id: "commission-enrollment-removed",
    accountStatus: "REMOVED",
    person: {
      id: "person-casey",
      displayName: "Casey Martin",
      pgaId: "11223344"
    },
    program: grpProgramSummary
  }
];
